import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import s from "./FunctionalButtonBar.module.scss";
import ColumnFilter from "components/ColumnFilter/ColumnFilter";
import TextMAS from "components/TextMAS/TextMAS";
import ButtonMAS from "ButtonMAS/ButtonMAS";
import { Edit } from "@mui/icons-material";

const COMPONENT_LOCALE_KEY = "component.functionalButtonBar.";

const FunctionalButtonBar = ({
  loading,
  customBtnLoading,
  approvingAll,
  rejectingAll,
  updatingAll,
  changingAll,
  exporting,
  exportBtn, // export flag
  handleExport,
  selectedItemNumber,
  customBtn, // custom flag
  customBtnName,
  customBtnIcon,
  handleCustomBtn,
  createBtn, // create flag
  handleCreate,
  isCreateLoading,
  approveAllBtn, // approve all flag
  handleApproveAll,
  rejectAllBtn, // reject all flag
  handleRejectAll,
  updateAllBtn, // update all flag
  handleUpdateAll,
  changeAllBtn, // change all flag
  handleChangeAll,
  refreshBtn, // refresh flag
  handleRefresh,
  columnDisplayBtn, // column display flag
  columnDisplayProps,
}) => {
  const { t } = useTranslation();

  const [columnDisplayDialog, setColumnDisplayDialog] = useState({
    open: false,
    position: 0,
  });

  const openColumnDisplay = (e) => {
    const position = e.target.getBoundingClientRect().top;
    setColumnDisplayDialog({
      open: true,
      position: position,
    });
    return;
  };

  const closeColumnDisplay = () => {
    setColumnDisplayDialog({
      ...columnDisplayDialog,
      open: false,
    });
    return;
  };

  return (
    <div className={s.functionalBtnBarInnerContent}>
      {!!selectedItemNumber && (
        <TextMAS>
          {t(COMPONENT_LOCALE_KEY + "selectedTableNumber.1")}
          {selectedItemNumber}
          {t(COMPONENT_LOCALE_KEY + "selectedTableNumber.2")}
        </TextMAS>
      )}
      {customBtn && (
        <ButtonMAS
          variant="bordered"
          size="table-bar-button"
          onClick={handleCustomBtn}
          disabled={loading}
          isLoading={customBtnLoading}
          startIcon={customBtnIcon}
        >
          {customBtnName}
        </ButtonMAS>
      )}
      {createBtn && (
        <ButtonMAS
          variant="bordered"
          size="table-bar-button"
          onClick={handleCreate}
          isLoading={isCreateLoading}
          disabled={isCreateLoading}
          // no loading blocking for create button
          // disabled={loading}
          startIcon={<AddIcon />}
        >
          {t(COMPONENT_LOCALE_KEY + "title.create")}
        </ButtonMAS>
      )}
      {approveAllBtn && (
        <ButtonMAS
          variant="bordered"
          size="table-bar-button"
          onClick={handleApproveAll}
          disabled={loading}
          isLoading={approvingAll}
          startIcon={<CheckCircleIcon />}
        >
          {t(COMPONENT_LOCALE_KEY + "title.approveAll")}
        </ButtonMAS>
      )}
      {rejectAllBtn && (
        <ButtonMAS
          variant="bordered"
          size="table-bar-button"
          onClick={handleRejectAll}
          disabled={loading}
          isLoading={rejectingAll}
          startIcon={<CancelIcon />}
        >
          {t(COMPONENT_LOCALE_KEY + "title.rejectAll")}
        </ButtonMAS>
      )}
      {updateAllBtn && (
        <ButtonMAS
          variant="bordered"
          size="table-bar-button"
          onClick={handleUpdateAll}
          disabled={loading}
          isLoading={updatingAll}
          startIcon={<Edit />}
        >
          {t(COMPONENT_LOCALE_KEY + "title.updateAll")}
        </ButtonMAS>
      )}
      {changeAllBtn && (
        <ButtonMAS
          variant="bordered"
          size="table-bar-button"
          onClick={handleChangeAll}
          disabled={loading}
          isLoading={changingAll}
          startIcon={<EditIcon />}
        >
          {t(COMPONENT_LOCALE_KEY + "title.changeAll")}
        </ButtonMAS>
      )}
      {exportBtn && (
        <ButtonMAS
          variant="bordered"
          size="table-bar-button"
          onClick={handleExport}
          disabled={loading}
          isLoading={exporting}
          startIcon={<DownloadIcon />}
        >
          {t(COMPONENT_LOCALE_KEY + "title.export")}
        </ButtonMAS>
      )}
      {refreshBtn && (
        <ButtonMAS
          variant="bordered"
          size="table-bar-button"
          onClick={handleRefresh}
          disabled={loading}
          startIcon={<RefreshIcon />}
        >
          {t(COMPONENT_LOCALE_KEY + "title.refresh")}
        </ButtonMAS>
      )}
      {columnDisplayBtn && (
        <>
          <ButtonMAS
            variant={columnDisplayDialog.open ? "primary" : "bordered"}
            size="table-bar-button"
            onClick={openColumnDisplay}
            disabled={loading}
            startIcon={<ViewColumnIcon />}
          >
            {t(COMPONENT_LOCALE_KEY + "title.column")}
          </ButtonMAS>
          <ColumnFilter
            columnDisplayDialog={columnDisplayDialog}
            dialogOncloseFn={closeColumnDisplay}
            columns={columnDisplayProps.columns}
            columnsArray={columnDisplayProps.columnsArray}
            setColumnsArray={columnDisplayProps.setColumnsArray}
            rememberPreference={columnDisplayProps.rememberPreference}
          />
        </>
      )}
    </div>
  );
};

export default React.memo(FunctionalButtonBar);
